export default {
  SECTIONS_FETCHED: 'SECTIONS_FETCHED',
  SECTION_LOAD: 'SECTION_LOAD',
  SECTION_DETAIL: 'SECTION_DETAIL',
};
